import { render, staticRenderFns } from "./wbItem.vue?vue&type=template&id=dd4ef93c&"
import script from "./wbItem.vue?vue&type=script&lang=js&"
export * from "./wbItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports